import React, { FunctionComponent, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { TeacherInfo } from "../../../../../store/onboarding/types";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";
import { ValueType } from "react-select/src/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

type OwnProps = {
  searchString: string;
  setSearchString: React.Dispatch<React.SetStateAction<string>>;
  selectedTeacherId: number | undefined;
  setSelectedTeacherId: React.Dispatch<
    React.SetStateAction<number | undefined>
  >;
};

type Props = OwnProps;

const FbaFilters: FunctionComponent<Props> = (props) => {
  const {
    searchString,
    setSearchString,
    selectedTeacherId,
    setSelectedTeacherId,
  } = props;

  const teachersRoster = useSelector(
    (s: ApplicationState) => s.onboarding.teachersRoster
  );
  const isLoadingGetTeachers = useSelector(
    (s: ApplicationState) => s.onboarding.isLoading.getTeachers
  );

  const handleSelectedTeacherChange = (
    value: ValueType<TeacherInfo, false>
  ) => {
    setSelectedTeacherId(value ? (value as TeacherInfo).user.id : undefined);
  };

  let timeout: any = null;

  const handleGroupSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (timeout) clearTimeout(timeout);
    const { value } = event.target;
    timeout = setTimeout(() => {
      setSearchString(value);
    }, 500);
  };

  return (
    <div>
        <div className="d-flex align-items-center">
          <InputGroup className="filterSearchDesktop mr-4 px-1" style={{width:"300px"}}>
            <InputGroup.Prepend>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              type="text"
              placeholder="Search"
              // value={props.studentsFilter}
              onChange={handleGroupSearchChange}
              className="filterSearchHeight"
            />
          </InputGroup>
          <div style={{ minWidth: 250 }}>
            <Select
              isClearable
              isLoading={isLoadingGetTeachers}
              placeholder="Educator"
              value={
                selectedTeacherId !== undefined
                  ? teachersRoster.find((t) => t.user.id === selectedTeacherId)
                  : undefined
              }
              options={teachersRoster}
              getOptionLabel={({ user }: TeacherInfo) =>
                `${user.first_name} ${user.last_name}`
              }
              getOptionValue={({ user }: TeacherInfo) => user.id.toString()}
              onChange={handleSelectedTeacherChange}
            />
          </div>
        </div>
      <hr />
    </div>
  );
};

export default FbaFilters;
